import { AsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit'

import { AppThunkApiConfig } from 'reduxTyped'
import {
  backToPro,
  cancelScheduledChangePlan,
  cancelSubscription,
  fetchPro,
  switchProduct,
} from 'common/billing/actions/billingActions'
import { getStripeCheckoutURL } from 'common/billing/actions/stripeCheckoutActions'
import { upgrade } from 'common/billing/actions/upgradeActions'
import { setPaywallShown } from 'common/billing/actions/upgradeRequestActions'
import { BillingState } from 'common/billing/interfaces/billing'

const initialState: Readonly<BillingState> = {
  fetchingUpgrade: false,
  fetchingUpdateCardDetails: false,
  fetchingCancelSubscription: false,
  fetchingCancelScheduledChangePlan: false,
  fetchingBackToPro: false,
  fetchingPro: false,
  isStripeCheckoutReady: true,
  fetchingSwitchProduct: false,
  isPaywallShown: false,
}

export const billingStateSlice = createSlice({
  name: 'state',
  initialState: initialState as BillingState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(setPaywallShown.match, (state, action) => {
      state.isPaywallShown = action.payload
    })

    const bindLoading = <Result, Options>(
      thunk: AsyncThunk<Result, Options, AppThunkApiConfig>,
      key: keyof BillingState,
    ) => {
      builder
        .addMatcher(thunk.pending.match, (state) => {
          state[key] = true
        })
        .addMatcher(isAnyOf(thunk.fulfilled.match, thunk.rejected.match), (state) => {
          state[key] = false
        })
    }

    bindLoading(getStripeCheckoutURL, 'isStripeCheckoutReady')
    bindLoading(cancelSubscription, 'fetchingCancelSubscription')
    bindLoading(cancelScheduledChangePlan, 'fetchingCancelScheduledChangePlan')
    bindLoading(backToPro, 'fetchingBackToPro')
    bindLoading(fetchPro, 'fetchingPro')
    bindLoading(switchProduct, 'fetchingSwitchProduct')
    bindLoading(upgrade, 'fetchingUpgrade')
  },
})
